"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// calculates the total price for the cruise
var lodash_1 = require("lodash");
function allBuyerPaxes(state, getters) {
    var paxes = [];
    var _loop_1 = function (cabin) {
        var cabinPaxes = lodash_1.cloneDeep(getters[cabin + '/pax/all']);
        var cabinAges = getters[cabin + '/pax/buyerAgeValues'];
        cabinPaxes = lodash_1.map(cabinPaxes, function (pax, index) {
            pax.age = cabinAges[index];
            pax.index = index;
            pax.cabin = cabin;
            return pax;
        });
        paxes = lodash_1.concat(paxes, cabinPaxes);
    };
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        _loop_1(cabin);
    }
    return paxes;
}
exports.default = allBuyerPaxes;
//# sourceMappingURL=allBuyerPaxes.js.map